import {useEffect, useState} from 'react';
import {$api} from '../../api/api';
import {normalizeAlarmInfo} from '../helpers/alarms';

const EMPTY_ALARMS = {activeAlerts: [], activeAlertLevels: []};

export default function useAlarms({publicId, stopId}) {
    const [snapshot, setSnapshot] = useState(null);

    useEffect(() => {
        let disposed = false;
        let inFlight = false;
        const controller = new AbortController();

        async function fetchAlarms() {
            if (inFlight) return;
            inFlight = true;
            try {
                const response = await $api.get('/api/info-hub/alarms', {
                    params: {publicId, stopId},
                    signal: controller.signal,
                    timeout: 10_000,
                });
                const alarms = normalizeAlarmInfo(response.data);
                if (!disposed) setSnapshot({publicId, stopId, alarms});
            } catch (error) {
                // Keep the last known alarm until a successful response changes it.
                if (!disposed) console.error('Error fetching alarms:', error);
            } finally {
                inFlight = false;
            }
        }

        fetchAlarms();
        const interval = setInterval(fetchAlarms, 10_000);
        return () => {
            disposed = true;
            controller.abort();
            clearInterval(interval);
        };
    }, [publicId, stopId]);

    return snapshot && snapshot.publicId === publicId && snapshot.stopId === stopId
        ? snapshot.alarms
        : EMPTY_ALARMS;
}
